import {Component, OnInit} from '@angular/core';
import {Sensor} from '../../../classes/Sensor';
import {FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from '../../dialog/confirm-dialog/confirm-dialog.component';
import {SensorEditComponent} from '../sensor-edit/sensor-edit.component';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';
import {RelayBoardService} from '../../../services/relay-board.service';
import {RelayBoard} from '../../../classes/RelayBoard';
import {SensorService} from '../../../services/sensor.service';

@Component({
  selector: 'app-sensor-list',
  styleUrls: ['./sensor-list.component.scss'],
  templateUrl: './sensor-list.component.html',
})
export class SensorListComponent implements OnInit {

  public sensors: Sensor[];
  public errorMessage: string;
  private currentDialog = null;
  private offices: Map<number, Office>;
  private relayBoards: Map<number, RelayBoard>;

  constructor(private sensorService: SensorService,
              private modalService: NgbModal,
              private officeService: OfficeService,
              private relayBoardService: RelayBoardService) {
  }

  ngOnInit(): void {
    this.updateList();

    this.officeService.getAll().subscribe({
      next: (response: Office[]) =>
        this.offices = new Map(response.map(office => [office.id, office]))
    });

    this.relayBoardService.getAll().subscribe({
      next: (response: RelayBoard[]) =>
        this.relayBoards = new Map(response.map(relayBoard => [relayBoard.id, relayBoard]))
    });
  }

  private updateList(): void {
    this.sensorService.getAll().subscribe({
        next: (response: Sensor[]) => this.sensors = response,
        error: (error) => this.errorMessage = error.error.error
      });
  }

  openEditModal(sensor: Sensor): void {
    this.currentDialog = this.modalService.open(SensorEditComponent,
      {
        scrollable: true,
        windowClass: 'modal-sensor-edit',
        size: 'lg',
        centered: true,
      });

    this.currentDialog.componentInstance.sensor = sensor;

    this.currentDialog.result.then(
      (result) => {
        if (result instanceof FormGroup) {
          const editedSensor = new Sensor(result.value);

          this.sensorService.addOrEdit(editedSensor).subscribe({
            next: () => this.updateList(),
            error: (error) => this.errorMessage = error.error.error
          });
        }
      },
      (error) => { console.log('Dialog close error: ' + error); }
    );
  }

  openDeleteConfirmModal(sensor: Sensor): void {
    this.currentDialog = this.modalService.open(ConfirmDialogComponent,
      {
        scrollable: true,
        windowClass: 'modal-confirm',
        size: 'md',
        centered: true,
        // keyboard: false,
        // backdrop: 'static'
      });

    this.currentDialog.componentInstance.message =
      'Are you sure that you want to delete sensor ' + sensor.id + '?';

    this.currentDialog.result.then((result) => {
      if (result.status === 'confirmed') {
        this.sensorService.delete(sensor.id).subscribe({
          next: () => this.updateList(),
          error: (error) => this.errorMessage = error.error.error
        });
      }
    }, (error) => {
      console.log('Dialog close error: ' + error);
    });
  }

  getOffice(officeId: number): string {
    const office = this.offices.get(officeId);
    return office.city + ', ' + office.address;
  }

  getRelayBoard(relayBoardId: number): string {
    const relayBoard = this.relayBoards.get(relayBoardId);
    return relayBoard.name;
  }
}
